module.exports = __webpack_public_path__ + "img/sec4_5_.71db35ed.png";